import script from "./InventoryWareHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryWareHouse.vue?vue&type=script&setup=true&lang=js"

import "./InventoryWareHouse.vue?vue&type=style&index=0&id=607cba64&lang=css"

const __exports__ = script;

export default __exports__